import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/admin/admin.service';
import { HomePageService } from '../homepage.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {
  selectedAppointment: any = {};
  servicesList: any[] = [];
  selectedServiceName = '';
  selectedServiceId = '';

  constructor(
    private homePageService: HomePageService,
    private adminService:AdminService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const session = (this.router.url).split('/')[2];
    this.homePageService.userAppointment({ session_id: session }).subscribe((result)=> {
      this.adminService.details({ Id: result['data'] }).subscribe((data: any) => {
        this.selectedAppointment = data.success.userQuery;
        this.selectedServiceId = this.selectedAppointment.serviceId;
        this.homePageService.servicesList().subscribe((data: any) => {
          this.servicesList = data.serviceList;
          for (let service of data.serviceList) {
            if (service._id == this.selectedServiceId) {
              this.selectedServiceName = service.title;
            }
          }
        });
      });
    });
  }
}
